import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "23",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ED0006",
      "fill-rule": "evenodd",
      d: "M18.632 20.05a11.34 11.34 0 0 1-7.33 2.667C5.06 22.717 0 17.717 0 11.55S5.06.383 11.301.383c2.797 0 5.357 1.004 7.33 2.668A11.34 11.34 0 0 1 25.963.383c6.242 0 11.301 5 11.301 11.167s-5.06 11.167-11.3 11.167a11.34 11.34 0 0 1-7.331-2.668",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F9A000",
      "fill-rule": "evenodd",
      d: "M18.632 20.05c2.43-2.05 3.97-5.097 3.97-8.5s-1.54-6.451-3.97-8.5a11.34 11.34 0 0 1 7.33-2.667c6.241 0 11.301 5 11.301 11.167s-5.06 11.167-11.3 11.167a11.34 11.34 0 0 1-7.331-2.668",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF5E00",
      "fill-rule": "evenodd",
      d: "M18.632 20.049c2.43-2.048 3.97-5.096 3.97-8.5 0-3.402-1.54-6.45-3.97-8.498-2.43 2.048-3.97 5.096-3.97 8.499s1.54 6.45 3.97 8.499",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }